module.exports = __webpack_public_path__ + "static/image_FSA-e00f7b5e07a58470a5c26f46689eceac.jpg";